<template>
  <div class="result-page-wrapper">

    <!-- خلفية (تختفي في الطباعة) -->
    <div class="background-shapes d-print-none"></div>

    <div class="container py-5 position-relative z-index-1">
 <div class="row justify-content-center mb-3 d-print-none">
        <div class="col-lg-8">
          <div class="alert alert-warning border-0 shadow-sm rounded-4 p-3 text-center animate__animated animate__fadeInDown" style="background-color: rgba(255, 193, 7, 0.9);">
            <div class="d-flex align-items-center justify-content-center text-dark">
              <i class="fas fa-exclamation-triangle fs-4 ms-3"></i>
              <div>
                <h6 class="fw-bold mb-1">تنبيه هام للمستخدمين</h6>
                <p class="mb-0 small">نشهد حالياً ضغطاً هائلاً على الخوادم؛ يرجى التحلي بالصبر وعدم تكرار المحاولة في أوقات متقاربة لضمان وصول الجميع لنتائجهم بنجاح.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 1. الهيدر والبحث -->
      <div class="row justify-content-center mb-4 d-print-none">
        <div class="col-lg-8 text-center" data-aos="fade-down">
           <h1 class="text-white fw-bold title-shadow mb-2">نتيجة إتمام مرحلة التعليم الأساسي الشهادة الإعدادية</h1>
          <h4 class="text-gold mb-4"> محافظة شمال سيناء - الدور الأول 2026</h4>

          <div class="search-card p-4 bg-white rounded-4 shadow-lg mb-4">
            <form @submit.prevent="getResult">
              <div class="input-group input-group-lg border rounded-pill overflow-hidden">
                <span class="input-group-text bg-white border-0 ps-4"><i class="fas fa-search text-primary"></i></span>
                <input
                  type="number"
                  v-model="seatNumber"
                  class="form-control border-0 fw-bold fs-4 text-center text-primary"
                  placeholder="أدخل رقم الجلوس"
                  required
                >
                <button class="btn btn-primary px-5 fw-bold" type="submit" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <span v-else>بحث</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- ======================================================== -->
      <!-- الحالة 1: النتيجة محجوبة (إظهار الاشتراك) -->
      <!-- ======================================================== -->
    <div v-if="result && result.is_published === false" class="row justify-content-center animate__animated animate__fadeInUp">
    <div class="col-md-8 col-lg-7">
        <div class="card border-0 shadow-2xl rounded-4 overflow-hidden bg-white mt-4 border-top border-warning border-5">
            
            <!-- الجزء العلوي: أيقونة الانتظار والمكانة الرسمية -->
            <div class="bg-light p-5 text-center position-relative border-bottom">
                <div class="icon-pulse-container mx-auto shadow-sm d-flex align-items-center justify-content-center bg-white border"
                     style="width: 110px; height: 110px; border-radius: 50%;">
                    <i class="fas fa-file-signature text-primary fa-3x animate__animated animate__pulse animate__infinite"></i>
                </div>
                <div class="mt-3">
                    <span class="badge bg-primary px-3 py-2 rounded-pill">نظام النتائج الإلكتروني</span>
                </div>
            </div>

            <div class="card-body p-4 p-md-5">
                <!-- بيانات الطالب المستعلم عنه -->
                <div class="text-center mb-5">
                    <h5 class="text-muted small fw-bold mb-3 text-uppercase letter-spacing-1">مرحباً بك</h5>
                    <h2 class="fw-extrabold text-dark mb-1">{{ result.student.name }}</h2>
                    <p class="text-muted fs-6"><i class="fas fa-school me-1"></i> {{ result.student.school }}</p>
                </div>

                <!-- رسالة الاعتماد الرسمية -->
                <div class="official-notice p-4 rounded-4 mb-4 border-start border-5 border-warning bg-warning bg-opacity-10">
                    <div class="d-flex align-items-start gap-3">
                        <i class="fas fa-stamp text-warning fs-2 mt-1"></i>
                        <div>
                            <h5 class="fw-bold text-dark mb-2">في انتظار الاعتماد الرسمي</h5>
                            <p class="text-dark mb-0 opacity-75 lh-base">
                                جاري حالياً الانتهاء من الإجراءات الإدارية ورفع الكشوف النهائية 
                                <strong>لاعتماد السيد المحافظ</strong> للنتيجة رسمياً خلال الساعات القليلة القادمة.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- رسالة الاعتذار والضغط التقني -->
                <div class="technical-notice p-4 rounded-4 mb-5 border-start border-5 border-info bg-info bg-opacity-10">
                    <div class="d-flex align-items-start gap-3">
                        <i class="fas fa-exclamation-triangle text-info fs-3 mt-1"></i>
                        <div>
                            <h6 class="fw-bold text-dark mb-2 text-info">توضيح بخصوص أداء الموقع</h6>
                            <p class="text-muted small mb-0 lh-lg">
                                نظراً لآلاف طلبات الدخول المتزامنة حالياً، قد يواجه بعض المستخدمين بطئاً في استجابة الموقع. 
                                <strong>نعتذر بشدة</strong> عن أي عطل فني قد يحدث نتيجة هذا الضغط الهائل الخارج عن إرادتنا، ونعمل جاهدين لتوفير أفضل تجربة لكم.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- قسم الاشتراك البديل (لتجنب الضغط) -->
                <!-- <div class="subscription-section bg-dark text-white p-4 p-md-5 rounded-4 shadow-lg">
                    <div class="text-center mb-4">
                        <h5 class="fw-bold mb-2 text-success">
                            <i class="fab fa-whatsapp me-2"></i> لا داعي لتكرار الدخول
                        </h5>
                        <p class="text-white-50 small">اشترك الآن وسنرسل لك نتيجتك (الدرجات والمجموع) مباشرة على واتساب فور الاعتماد</p>
                    </div>

                    <form @submit.prevent="subscribeToNotify" class="mx-auto" style="max-width: 400px;">
                        <div class="input-group input-group-lg mb-3 shadow-sm rounded-3 overflow-hidden">
                            <span class="input-group-text bg-white border-0 text-dark">
                                <i class="fas fa-mobile-alt"></i>
                            </span>
                            <input type="tel"
                                   v-model="phone"
                                   class="form-control border-0 ps-0 fw-bold text-center"
                                   placeholder="أدخل رقم الموبايل"
                                   required>
                        </div>
                        <button type="submit"
                                class="btn btn-success btn-lg w-100 fw-bold shadow-sm py-3 transition-all hover-lift"
                                :disabled="subscribing">
                            <span v-if="subscribing" class="spinner-border spinner-border-sm ms-2"></span>
                            <span v-else>
                                <i class="fas fa-bell me-2"></i> تفعيل الإشعارات المجانية
                            </span>
                        </button>
                    </form>
                </div> -->
            </div>

            <!-- فوتر البطاقة -->
            <div class="card-footer bg-light border-0 py-3 text-center">
                <button @click="result = null" class="btn btn-link text-decoration-none text-muted small">
                    <i class="fas fa-chevron-right me-1"></i> العودة للبحث برقم آخر
                </button>
            </div>
        </div>
    </div>
</div>

      <!-- ======================================================== -->
      <!-- الحالة 2: النتيجة متاحة (عرض الشهادة) -->
      <!-- ======================================================== -->
    <div v-if="result && result.is_published === true" class="animate__animated animate__fadeIn">
    
    <!-- منطقة بيان الدرجات الرسمي -->
    <div class="row justify-content-center" id="printMe">
        <div class="col-lg-10 col-md-12">
            
            <div class="official-sheet bg-white shadow-lg p-3 p-md-5 mx-auto position-relative overflow-hidden rounded-4">
                
                <!-- علامة مائية خلفية (اختياري) -->
                <div class="watermark-logo"></div>

                <!-- 1. الترويسة العلوية -->
                <div class="row border-bottom border-3 border-primary pb-3 mb-4 align-items-center header-row text-start text-md-start">
                    <div class="col-md-4 mb-3 mb-md-0">
                        <h6 class="fw-bold mb-1">محافظة شمال سيناء</h6>
                        <h6 class="fw-bold mb-1">مديرية التربية والتعليم</h6>
                        <h6 class="fw-bold mb-0">لجنة النظام والمراقبة</h6>
                    </div>
                    <div class="col-md-4 mb-3 mb-md-0 text-center">
                        <h3 class="fw-bolder text-primary mb-1">بيان درجات</h3>
                        <span class="badge bg-primary-subtle text-primary border border-primary-position px-3 py-2 rounded-pill">
                            إتمام الدراسة بمرحلة التعليم الأساسي - 2026
                        </span>
                    </div>
                    <div class="col-md-4 text-center text-md-end">
                        <div class="qr-placeholder d-none d-md-inline-block border p-1 bg-light">
                            <!-- يمكن وضع QR Code هنا مستقبلاً -->
                            <i class="fas fa-qrcode fa-3x text-muted"></i>
                        </div>
                    </div>
                </div>

                <!-- 2. صندوق بيانات الطالب المحسن (متجاوب) -->
                <div class="student-profile-box mb-4">
                    <div class="row g-3">
                        <div class="col-12">
                            <div class="info-item d-flex align-items-center p-3 bg-light rounded-3 border-start border-4 border-primary">
                                <span class="text-muted fw-bold ms-3" style="min-width: 100px;">اسم الطالب:</span>
                                <span class="fw-bolder fs-4 text-dark">{{ result.student.name }}</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="info-item d-flex align-items-center p-3 bg-light rounded-3 border-start border-4 border-secondary">
                                <span class="text-muted fw-bold ms-3" style="min-width: 100px;">المدرسة:</span>
                                <span class="fw-bold text-dark">{{ result.student.school }}</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="info-item d-flex align-items-center p-3 bg-light rounded-3 border-start border-4 border-dark">
                                <span class="text-muted fw-bold ms-3" style="min-width: 100px;">رقم الجلوس:</span>
                                <span class="fw-bold text-dark fs-5">{{ result.student.seat_number }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 3. جداول الدرجات -->
                <div class="results-tables">
                    
                    <!-- أولاً: المواد الأساسية -->
                    <div class="table-container mb-5">
                        <div class="d-flex align-items-center mb-3">
                            <i class="fas fa-star text-primary ms-2"></i>
                            <h5 class="fw-bold mb-0">أولاً: المواد الأساسية (تضاف للمجموع)</h5>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered border-secondary text-center align-middle custom-table">
                                <thead class="table-primary">
                                    <tr>
                                        <th width="40%">المادة الدراسية</th>
                                        <th>العظمى</th>
                                        <th>الصغرى</th>
                                        <th>الدرجة</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sub in result.basic_subjects" :key="sub.id">
                                        <td class="text-start fw-bold ps-4">{{ sub.name }}</td>
                                        <td>{{ sub.max }}</td>
                                        <td>{{ sub.min }}</td>
                                        <td class="fw-bolder fs-5" :class="sub.is_fail ? 'text-danger' : 'text-primary'">
                                            {{ sub.degree }}
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot class="table-light fw-bold border-top border-3">
                                    <tr>
                                        <td class="text-start ps-4 fs-5">المجموع الكلي</td>
                                        <td class="fs-5">{{ result.max_total }}</td>
                                        <td class="fs-5">{{ result.max_total / 2 }}</td>
                                        <td class="fs-3 fw-bolder" :class="result.status === 'pass' ? 'text-success' : 'text-danger'">
                                            {{ result.total_score }}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <!-- ثانياً: المواد غير المضافة -->
                    <div class="table-container mb-4">
                        <div class="d-flex align-items-center mb-3">
                            <i class="fas fa-list text-secondary ms-2"></i>
                            <h5 class="fw-bold mb-0 text-secondary">ثانياً: مواد لا تضاف للمجموع / أنشطة</h5>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered border-secondary text-center align-middle custom-table table-sm">
                                <thead class="table-secondary">
                                    <tr>
                                        <th width="40%">المادة</th>
                                         <th>العظمى</th> 
                                        <th>الصغرى</th> 
                                        <th>الدرجة</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sub in result.non_added_subjects" :key="sub.id">
                                        <td class="text-start ps-4 fw-bold">{{ sub.name }}</td>
                                         <td>{{ sub.max }}</td> 
                                        <td>{{ sub.min }}</td> 
                                        <td class="fw-bold">{{ sub.degree }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- 4. النتيجة النهائية -->
                <!-- <div class="status-footer mt-5 p-4 rounded-4 text-center border-3 border" 
                     :class="result.status === 'pass' ? 'bg-success-subtle border-success' : 'bg-danger-subtle border-danger'">
                    <h4 class="fw-bolder mb-0" :class="result.status === 'pass' ? 'text-success' : 'text-danger'">
                        الحالة العامة للطالب: {{ result.status_text }}
                    </h4>
                </div> -->

                <!-- زر الطباعة (يختفي عند الطباعة) -->
                <div class="text-center py-4 d-print-none">
                    <button @click="printPage" class="btn btn-primary btn-md px-5 fw-bold shadow">
                        <i class="fas fa-print ms-2"></i> طباعة بيان الدرجات
                    </button>
                    <button @click="result = null" class="btn btn-outline-secondary btn-lg px-4 ms-2 fw-bold">
                        بحث جديد
                    </button>
                </div>

            </div>
        </div>
    </div>
</div>

      <!-- رسالة خطأ -->
      <div v-if="error" class="row justify-content-center mt-4">
        <div class="col-md-6">
          <div class="alert alert-danger shadow text-center border-0 fw-bold">
            <i class="fas fa-exclamation-circle me-2"></i> {{ error }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/api';
//import html2canvas from 'html2canvas';

export default {
  name: "ResultPortal",
  data() {
    return {
      seatNumber: '',
      loading: false,
      result: null,
      error: null,
      viewMode: 'card',
      processingShare: false,
      phone: '',
      subscribing: false
    };
  },
  methods: {
    async getResult() {
      if(!this.seatNumber) return;
      this.loading = true;
      this.error = null;
      this.result = null;

      try {
        const res = await api.get(`/public/result/${this.seatNumber}`);
        this.result = res.data;
      } catch (e) {
        if(e.response && e.response.status === 404) {
            this.error = "رقم الجلوس غير صحيح، يرجى التأكد والمحاولة مرة أخرى.";
        } else {
            this.error = "حدث خطأ في الاتصال بالسيرفر.";
        }
      } finally {
        this.loading = false;
      }
    },

    async subscribeToNotify() {
        if(!this.phone || this.phone.length < 10) return alert("رقم الهاتف غير صحيح");
        this.subscribing = true;
        try {
            await api.post('/public/subscribe-result', {
                seat_number: this.result.student.seat_number,
                phone: this.phone
            });
            alert("تم الاشتراك بنجاح! ستصلك رسالة واتساب.");
            this.phone = '';
        } catch(e) {
            alert("حدث خطأ أثناء الاشتراك.");
        } finally {
            this.subscribing = false;
        }
    },

    getStatusClass(status) {
        if(status === 'pass') return 'bg-success';
        if(status === 'round2') return 'bg-danger';
        return 'bg-warning text-dark';
    },

    getScoreColor(percent) {
        if(percent >= 85) return 'score-excellent';
        if(percent >= 75) return 'score-verygood';
        if(percent >= 65) return 'score-good';
        if(percent >= 50) return 'score-pass';
        return 'score-fail';
    },

    printResult() { window.print(); },

    async shareDesign() {
        this.processingShare = true;
        const element = document.getElementById('certificateNode');
        if (!element) return;
        try {
            const canvas = await html2canvas(element, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
            canvas.toBlob(async (blob) => {
                const file = new File([blob], "result.png", { type: "image/png" });
                if (navigator.share && navigator.canShare({ files: [file] })) {
                    await navigator.share({ files: [file], title: 'النتيجة' });
                } else {
                    const link = document.createElement('a');
                    link.href = canvas.toDataURL("image/png");
                    link.download = `Result-${this.seatNumber}.png`;
                    link.click();
                }
                this.processingShare = false;
            });
        } catch (error) { this.processingShare = false; }
    },
     printPage() {
         this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;800&display=swap');

.result-page-wrapper {
    font-family: 'Cairo', sans-serif;
    min-height: 100vh;
    background: linear-gradient(135deg, #002147 0%, #0d47a1 100%);
    position: relative;
    overflow-x: hidden;
}

.background-shapes {
    position: absolute;
    width: 100%; height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    z-index: 0;
}

.text-gold { color: #ffd700; }
.title-shadow { text-shadow: 0 4px 10px rgba(0,0,0,0.3); }

/* Card View */
.certificate-card {
    border: 1px solid rgba(0,0,0,0.1);
    background-image: linear-gradient(to bottom right, #fff, #f8f9fa);
}
.status-ribbon { position: absolute; top: 0; left: 0; right: 0; text-transform: uppercase; letter-spacing: 1px; }
.total-score-circle { position: relative; width: 120px; height: 120px; }
.circular-chart { display: block; margin: 0 auto; max-width: 100%; max-height: 100%; }
.circle-bg { fill: none; stroke: #eee; stroke-width: 2.5; }
.circle { fill: none; stroke-width: 2.5; stroke-linecap: round; animation: progress 1s ease-out forwards; }
.score-excellent .circle { stroke: #198754; }
.score-verygood .circle { stroke: #0d6efd; }
.score-good .circle { stroke: #0dcaf0; }
.score-fail .circle { stroke: #dc3545; }
.score-content { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex; flex-direction: column; align-items: center; line-height: 1; }
@keyframes progress { 0% { stroke-dasharray: 0 100; } }

/* Table View */
.official-sheet {
    border: 3px double #000;
    min-height: 297mm;
    background-color: #fff;
    position: relative;
    font-family: 'Times New Roman', 'Cairo', serif;
}
.watermark-logo {
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 300px; height: 300px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.05;
    z-index: 0;
    pointer-events: none;
}
.student-info-box { z-index: 1; position: relative; }
.grades-table th { background-color: #f0f0f0; font-weight: 800; border-width: 2px; }
.grades-table td { font-weight: 600; font-size: 15px; }
.total-row { background-color: #f8f9fa; border-top: 3px double #000; font-weight: 900; }
.btn-gold { background-color: #ffd700; border: none; }

/* Print */
@media print {
    .result-page-wrapper { background: white !important; }
    .search-card, .btn, .d-print-none, .background-shapes { display: none !important; }

    #printAreaCard .certificate-card {
        box-shadow: none !important;
        border: 2px solid #000 !important;
        width: 100%; position: absolute; left: 0; top: 0;
    }

    #printAreaTable .official-sheet {
        box-shadow: none !important;
        border: none;
        width: 100%; position: absolute; left: 0; top: 0;
    }

    .badge { border: 1px solid #000; color: black !important; }
    .progress-bar, .bg-dark, .bg-light { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    .text-white { color: black !important; }
    .bg-dark { color: white !important; background-color: black !important; }
    .text-success { color: black !important; font-weight: bold; }
    .text-danger { color: black !important; text-decoration: underline; }
}

.bg-orange-light {
    background-color: #fff3e0;
}
.text-orange {
    color: #e65100;
}
.border-dashed {
    border-style: dashed !important;
}
.extra-small {
    font-size: 0.75rem;
}
.hover-lift:hover {
    transform: translateY(-2px);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.transition-all {
    transition: all 0.3s ease;
}
.icon-pulse-container {
    position: relative;
    z-index: 1;
}
/* تأثير النبض خلف الأيقونة */
.icon-pulse-container::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 50%;
    z-index: -1;
    animation: custom-pulse 2s infinite;
}

@keyframes custom-pulse {
    0% { transform: scale(1); opacity: 0.8; }
    100% { transform: scale(1.6); opacity: 0; }
}

<style scoped>
/* أيقونة الساعة النابضة */
.animate-pulse {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% { transform: scale(1); filter: drop-shadow(0 0 0px rgba(255,193,7,0)); }
    50% { transform: scale(1.1); filter: drop-shadow(0 0 15px rgba(255,193,7,0.5)); }
    100% { transform: scale(1); filter: drop-shadow(0 0 0px rgba(255,193,7,0)); }
}

/* شريط المجموع الكلي */
.table-primary {
    background-color: rgba(26, 115, 232, 0.1) !important;
    border-top: 2px solid var(--primary-color);
}

/* الهيدر الخاص بالنتيجة */
.card-header {
    border-bottom: 0;
    position: relative;
}

.card-header::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 10%;
    right: 10%;
    height: 1px;
    background: rgba(255,255,255,0.2);
}

/* تنسيقات مخصصة للبيان الرسمي */
.official-sheet {
    border: 2px solid #eee;
    font-family: 'Cairo', sans-serif;
}

.custom-table th {
    padding: 12px;
    font-weight: 800;
}

.custom-table td {
    padding: 10px;
}

.bg-primary-subtle { background-color: #e7f1ff; }
.bg-success-subtle { background-color: #e6ffed; }
.bg-danger-subtle { background-color: #fff5f5; }

.info-item {
    transition: all 0.3s ease;
}

@media print {
    .official-sheet {
        border: none !important;
        box-shadow: none !important;
        padding: 0 !important;
    }
    .d-print-none { display: none !important; }
    body { background-color: white !important; }
    .rounded-4 { border-radius: 0 !important; }
}

/* تحسينات للشاشات الصغيرة */
@media (max-width: 768px) {
    .info-item {
        flex-direction: column;
        align-items: flex-start !important;
    }
    .info-item span {
        min-width: auto !important;
        margin-bottom: 5px;
    }
    .fs-3 { font-size: 1.5rem !important; }
    .fs-4 { font-size: 1.25rem !important; }
}
.fw-extrabold { font-weight: 800; }
.letter-spacing-1 { letter-spacing: 1px; }
.shadow-2xl { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15); }

.icon-pulse-container {
    position: relative;
    z-index: 1;
}
.icon-pulse-container::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: #0d6efd;
    opacity: 0.1;
    border-radius: 50%;
    z-index: -1;
    animation: custom-pulse 2s infinite;
}

@keyframes custom-pulse {
    0% { transform: scale(1); opacity: 0.3; }
    100% { transform: scale(1.8); opacity: 0; }
}

.hover-lift:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.2) !important;
}

.lh-lg { line-height: 1.8; }

/* ألوان مخصصة للحالات */
.bg-orange-light { background-color: #fff8e1; }
.text-orange { color: #f57c00; }
</style>
